import {Navigate, Outlet, Route, Routes} from "react-router-dom";
import App from "./App";
import Auth from "../containers/Auth/Auth";
import Dashboard from "../containers/Dashboard/Dashboard";
import AgentSubmission from "../containers/Agent.submission.form/Agent.submission.form"
import {AuthenticationImage} from "../components/common/Auth.login/Auth.login.image";
import LoaderDefault from "../components/common/Loader.default/Loader.default";
import {useEffect} from "react";
import useUserStore from "../data/User.store";
import AgentBase from "../containers/Agent.base/Agent.base";
import AgentSubmissionUpdate from "../containers/Agent.submission.form/Agent.submission.update";
import RatesForApproval from "../containers/RatesForApproval/RatesForApproval";
import RatesBase from "../containers/Rates.base/Rates.base";
import AgentReviewSearch from "../containers/Agent.review.search/Agent.review.search";
import AgentReviewForm from "../containers/Agent.review.form/Agent.review.form";
import ShippingTimelines from "../containers/Shipping.timelines/Shipping.Timelines";
import Shipments from "../containers/Shipments/Shipments";
import BookingCreate from "../components/project/Booking.create/Booking.create";
import ShipmentQueryResults from "../containers/ShipmentQueryResults/ShipmentQueryResults";

// {/* <Route path="rates" element={<ProtectedRoutes/>}> */}
// this works so far but it is hard coded in the ProtectedRoutes
// so try to figure out how to make it not hard-coded
// /rates/approvals
interface IProtectedRouteProps {
    isAllowed: boolean,
    redirectPath?: string,
    children?: any
}

const ProtectedRoute = ({
                            isAllowed,
                            redirectPath = '/dashboard',
                            children,
                        }: IProtectedRouteProps) => {
    if (!isAllowed) {
        return <Navigate to={redirectPath} replace/>;
    }

    return children ? children : <Outlet/>;
};

//should be controlling all data
function AppRouting() {
    const {user, checkUserExists, userExistsChecked} = useUserStore();
    useEffect(() => {
        if (!userExistsChecked) {
            checkUserExists();
        }
        //eslint-disable-next-line
    }, [])

    if (!userExistsChecked) {
        return <LoaderDefault text="Loading application..."/>
    }

    function permissionExists(permission: string) {
        if (user?.permissions) {
            return user?.permissions.indexOf(permission) !== -1
        } else {
            return false;
        }
    }

    return (
        <Routes>
            {!user ?
                <>
                    <Route path="auth" element={<Auth/>}>
                        <Route path="login" element={<AuthenticationImage/>}/>
                    </Route>
                    <Route path="agent" element={<AgentBase/>}>
                        <Route path="submission" element={<AgentSubmission/>}/>
                        <Route path="update" element={<AgentSubmissionUpdate/>}/>
                        <Route path="*" element={<Navigate replace to="/agent/submission"/>}/>
                    </Route>
                    <Route path="*" element={<Navigate replace to="/auth/login"/>}/>
                </>
                :
                <>
                    <Route path="/" element={<App/>}>
                        <Route index element={<Navigate replace to="dashboard"/>}/>
                        <Route path="rates" element={
                            <ProtectedRoute isAllowed={permissionExists("Rates For Approval")}>
                                <RatesBase/>
                            </ProtectedRoute>
                        }>
                            <Route path="approvals" element={<RatesForApproval/>}/>
                        </Route>
                        <Route path="bookings" element={
                            <ProtectedRoute isAllowed={permissionExists("Booking for Approval")}>
                                <div>Rates</div>
                            </ProtectedRoute>
                        }>
                            <Route path="approvals" element={<div>Bookings</div>}/>
                        </Route>
                        <Route path="dashboard" element={<Dashboard/>}/>
                        <Route path="create-booking" element={
                            <ProtectedRoute isAllowed={permissionExists("Create Booking")}>
                                <BookingCreate/>
                            </ProtectedRoute>
                        }/>

                        <Route path="agent" element={
                            <ProtectedRoute isAllowed={permissionExists("Agent Review")}/>
                        }>
                            <Route path="review" element={<AgentReviewSearch/>}>
                                <Route path=":agentId" element={<AgentReviewForm/>}/>
                            </Route>
                        </Route>
                        <Route path="shipment-tracking" element={
                            <ProtectedRoute isAllowed={permissionExists("Shipment Tracking")}>
                                <Shipments/>
                            </ProtectedRoute>
                        }>
                            <Route path="shipments" element={<ShipmentQueryResults/>}>
                                <Route path=":shipmentNumber" element={<ShippingTimelines/>}>

                                </Route>
                            </Route>
                        </Route>

                    </Route>
                    <Route path="*" element={<Navigate replace to="dashboard"/>}/>
                </>
            }
        </Routes>
    )
}

function RequireAuth({children, redirectTo}: any) {
    let isAuthenticated = localStorage.getItem("logged_in") === "true";
    return isAuthenticated ? children : <Navigate to={redirectTo}/>;
}

export default AppRouting;